module.exports = __webpack_public_path__ + "static/media/light-car-background.6663d3dc.png";